var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.9725C10.1801 3.9725 8.2975 5.85292 8.2975 8.175C8.2975 10.4949 10.1779 12.3775 12.5 12.3775C14.8221 12.3775 16.7025 10.4971 16.7025 8.175C16.7025 5.85294 14.8199 3.9725 12.5 3.9725ZM12.5 0C5.60861 0 0 5.60861 0 12.5C0 19.3914 5.60861 25 12.5 25C19.3914 25 25 19.3914 25 12.5C25 5.60861 19.3914 0 12.5 0ZM20.6694 20.8778C20.3917 16.6558 16.8414 13.8553 12.5 13.8553C8.15861 13.8553 4.61167 16.6558 4.33056 20.8778C2.14956 18.7499 0.788889 15.78 0.788889 12.5C0.788889 6.045 5.83333 0.877778 12.0833 0.833333C18.3333 0.788889 24.2111 6.045 24.2111 12.5C24.2111 15.7803 22.8504 18.75 20.6694 20.8778Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenProfile);
export default __webpack_public_path__ + "static/media/venProfile.1d1608751da55a7505a047c73a9532e9.svg";
export { ForwardRef as ReactComponent };